import React, { useState, useRef } from 'react'

import XIcon from '@uniiverse/library/assets/icons/x.svg'

import style from './index.css'

const EMPTY_VALUE_EVENT = { target: { value: '' } }

export const TextInput = (props) => {
  const {
    className,
    icon,
    input,
    highlightedIcon,
    withClearIcon,
    endIcon,
    inputProps,
  } = props

  const [highlightIcon, setHighlightIcon] = useState(false)
  const inputRef = useRef(null)

  const onInputFocus = () => { setHighlightIcon(true) }
  const onInputBlur = () => { setHighlightIcon(false) }
  const clearText = () => {
    inputProps.onChange(EMPTY_VALUE_EVENT)
    if (inputRef.current) inputRef.current.focus()
  }

  const showClearIcon = withClearIcon && inputProps.value
  const inputClassName = [
    style.input,
    icon ? style.inputWithIcon : '',
    showClearIcon || endIcon ? style.inputWithEndIcon : '',
    inputProps.className || '',
  ].join(' ')

  return (
    <div className={`${style.container} ${className || ''}`}>
      {
        icon && (
          <div className={`${style.icon} ${highlightedIcon || highlightIcon ? style.highlightedIcon : ''}`}>
            {icon}
          </div>
        )
      }
      {
        input || (
          <input
            {...inputProps}
            ref={inputRef}
            className={inputClassName}
            onFocus={onInputFocus}
            onBlur={onInputBlur}
            type="text"
          />
        )
      }
      {
        showClearIcon && (
          <div className={style.endIcon}><XIcon className={style.clearIcon} onClick={clearText} /></div>
        )
      }
      {endIcon && <div className={style.endIcon}>{endIcon}</div>}
    </div>
  )
}
